export default __webpack_public_path__ + "static/media/coder.676022f8.png";